// extracted by mini-css-extract-plugin
export default {"icon-label":"IconLabel_icon-label__zaTJq"};